define('lq/entityFiltersState',[
    'underscore'
], function (_) {
    'use strict';

    return {

        getStateOfEntityFilters: function (rootDrop) {
            var state = {};

            var entityFilters = _.filter(rootDrop.piping.dropFactory.createdDrops, function(drop) {
                return drop.data.type === 'EntityFilter';
            });

            _.each(entityFilters, function(entityFilter) {
                var appliedFilters = _.chain(entityFilter.getDropTargets())
                    .map(function (targetDrop) {
                        return {
                            drop: targetDrop,
                            filters: entityFilter.getMyActiveFiltersForTarget(targetDrop)
                        };
                    })
                    .filter(function (target) {
                        return target.filters.length;
                    })
                    .map(function (target) {
                        var appliedFilter = {
                            targetDrop: target.drop.data.name
                        };

                        var targetOptions = entityFilter.getOptionsForTarget(target.drop);

                        if (targetOptions.modalPopup) {
                            var parameters = rootDrop.piping.parameters;
                            appliedFilter.values = _.map(targetOptions.mappings, function (mapping) {
                                return {
                                    sourceName: mapping.sourceName,
                                    parameterValue: parameters.getValue(mapping.targetParameter)
                                };
                            });
                        }

                        return appliedFilter;
                    })
                    .value();

                if (appliedFilters.length)
                    state[entityFilter.data.id] = appliedFilters;
            });

            return JSON.stringify(state);
        },

        restoreStateOfFilters: function (rootDrop, json) {
            var state = JSON.parse(json);
            var parameters = rootDrop.piping.parameters;
            var entityFilters = _.filter(rootDrop.piping.dropFactory.createdDrops, function (drop) {
                return drop.data.type === 'EntityFilter';
            });

            var listShouldBeReloaded = {};

            _.each(entityFilters, function (entityFilter) {
                _.each(entityFilter.data.targets, function(targetList) {
                    if (!listShouldBeReloaded.hasOwnProperty(targetList.drop))
                        listShouldBeReloaded[targetList.drop] = false;
                });

                entityFilter.removeAppliedFilters();

                if (!state[entityFilter.data.id]) return;

                var storedFilters = state[entityFilter.data.id];

                _.each(storedFilters, function (dropFilter) {
                    var targetDrop = rootDrop.piping.dropFactory.findDropByName(dropFilter.targetDrop);
                    if (!targetDrop) return;

                    var targetOptions = entityFilter.getOptionsForTarget(targetDrop);
                    var filterInstance = entityFilter.createInstance(targetDrop, targetOptions, true);
                    entityFilter.addAsActiveFilterToTarget(filterInstance);

                    if (filterInstance.options.filterParameterName)
                        parameters.locals.setValue(filterInstance.options.filterParameterName, filterInstance.options.filterParameterValue);

                    if (filterInstance.options.mappings) {
                        _.each(filterInstance.options.mappings, function (mapping) {
                            var value = _.findWhere(dropFilter.values, { sourceName: mapping.sourceName });
                            if (!value) return;

                            var sourceDrop = rootDrop.piping.dropFactory.findDropByName(mapping.sourceName);
                            sourceDrop.setValue({
                                value: value.parameterValue
                            });
                            parameters.locals.setValue(mapping.targetParameter, value.parameterValue);

                            entityFilter.triggerEventForTargetIfEnabled(targetOptions, 'applyFilter');
                        });
                    }

                    entityFilter.dragToPosition(entityFilter.initialPosition);

                    listShouldBeReloaded[dropFilter.targetDrop] = true;
                });

            });

            var queriesBatch = [];

            _.each(listShouldBeReloaded, function (shouldBeReloaded, listName) {
                var theList = rootDrop.piping.dropFactory.findDropByName(listName);

                if (theList) {
                    if (shouldBeReloaded) {
                        queriesBatch.push({
                            queryName: theList.data.dataSource,
                            handler: function (response) {
                                _.each(theList.getDatasourceListenersWithSameParams(), function (listener) {
                                    listener.handler(response);
                                });
                            },
                            decorateDataFunc: function(params) {
                                theList.decorateQueryParams(params);
                            }
                        });
                    } else {
                        // wait until we've dispatched the queries
                        _.defer(function() {
                            theList.clear();
                        });
                    }
                        
                }
            });

            if (queriesBatch.length)
                rootDrop.piping.queryDispatcher.dispatchBatch(queriesBatch, rootDrop.piping);
        }
    };

});
